import React from 'react';

export const MeasureLine = () => (
    <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.35 6.26">
        <g>
            <polygon points="23.73 0 23.73 3.48 22.48 3.48 22.48 0 18.57 0 18.57 1.84 17.32 1.84 17.32 0 13.4 0 13.4 3.48 12.15 3.48 12.15 0 8.24 0 8.24 1.84 6.99 1.84 6.99 0 3.08 0 3.08 3.48 1.83 3.48 1.83 0 0 0 0 6.26 25.35 6.26 25.35 0 23.73 0"/>
        </g>
    </svg>
);
